import { DateTime } from 'luxon';

export function parseDate(value: string | null | undefined): Date | null {
    const trimmed = value?.trim?.() ?? '';
    if (!trimmed) return null;
    const date = new Date(trimmed);

    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTimeDisplay(value: string | Date | number | null | undefined): string {
    if (value == null || value === '') return '';

    const date = DateTime.fromJSDate(new Date(value));
    const dateTime = date.toFormat('MM/dd/yyyy');
    const time = new Intl.DateTimeFormat(navigator.language, {
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(value));

    return `${dateTime} - ${time}`;
}
